import React from 'react'
import req from 'reqwest';
import Users from 'json!../../www/resources/users.json'

export default {

    auth(login, password, handleResponse){
        req({
            url: "https://portal-experience-api.cloudhub.io/api/signin",
            method: 'POST',
            contentType: "application/json",
            crossOrigin: true,
            data: JSON.stringify({"login": login, "password": password})
        })
            .then((resp)=>this.handleAuthResponse(resp, login, handleResponse))
            .fail((err, msg) => this.handleError(err, msg, login, password, handleResponse))
            .always((resp) => {
            });
    },

    handleAuthResponse(resp, login, handleResponse){
        handleResponse(resp.patientId, login);
    },

    handleError(err, msg, login, password, handleResponse){
        let userId = "";
        for (let user in Users.users) {
            if (Users.users[user].login == login) {
                userId = Users.users[user].id;
                userId = Users.users[user].id;
            }
        }
        handleResponse(userId, login);
    },


};


/** WEBPACK FOOTER **
 ** ./src/app/services/UserService.js
 **/